import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    // },
    {
        cameraLocationId: 'NANGRFG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Ground Floor`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['NANWENG01', 'NANCIDG01', 'NANHDSG01', 'NANHGSG01', 'NANHGSG01B', 'NANCLOG01', 'NANLACG01', 'NANDEPG01'],
    },
    {
        cameraLocationId: 'NANWENG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Welcome to Nanjing`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANCIDG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Information Desk`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHDSG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Hand-Scrolls`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHGSG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Hanging Scrolls 1-5`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHGSG01B',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Hanging Scrolls 6-11`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANCLOG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Cloisonné`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANLACG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Lacquerwork`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANDEPG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Departure Lounge`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANFIRG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `First Floor`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['NANPORG01', 'NANTHEG01'],
    },
    {
        cameraLocationId: 'NANPORG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Porcelain`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANTHEG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Theatre`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },

];

export {CameraLocationsDB, FLOOR_NUMBER};
